const MAX_ZIP_SIZE_BYTES = 10 * 1024 * 1024;

export function validateZipAttachment(file) {
  if (!file) {
    return "";
  }

  if (!file.name.toLowerCase().endsWith(".zip")) {
    return "Endast .zip-filer är tillåtna.";
  }

  if (file.size > MAX_ZIP_SIZE_BYTES) {
    return "Filen får inte vara större än 10 MB.";
  }

  return "";
}
